import { UIChip } from "../../_core/components";
import { Block as BlockIcon, CheckCircle as CheckCircleIcon } from "../../_core/components/icons";

export interface UserStatusChipProps {
  isActive: boolean;
}

const UserStatusChip = ({ isActive }: UserStatusChipProps) => {
  return (
    <UIChip
      variant="outlined"
      icon={isActive ? <CheckCircleIcon /> : <BlockIcon />}
      label={isActive ? "Active" : "Disabled"}
      color={isActive ? "success" : "error"}
      data-testid="user-status-chip"
    />
  );
};

export default UserStatusChip;